import "../Portfolio.css";
function CardProjeto() {
  return (
    <div className="card">
        <div className="card-body-1">
          <img className="img-card" src="https://imagensemoldes.com.br/wp-content/uploads/2020/08/Tecnologia-PNG.png"/>
        </div>
        <div className="card-body-2">
          <p>Em linguística, a noção de texto é ampla e ainda aberta a uma definição mais precisa. Grosso modo, pode ser entendido como manifestação linguística das ideias de um autor, que serão interpretadas pelo leitor de acordo com seus conhecimentos linguísticos e culturais. Seu tamanho é variável.</p>
          <button className="card-button"type="button">ver</button>
        </div>
    </div>
  )
}

export default CardProjeto;